import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductContext from '@/product/context/product/productContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import UserContext from '@/product/context/user/userContext'

import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const Catalogue = (props) => {
    const { bulkProjectAction } = useContext(ProductContext)
    const [isLoading, setIsLoading] = useState(false)
    const { resetDropZone } = useContext(ProductCommonContext)
    const [reload, setReload] = useState(false)

    const { allCategory, allLocations, allCondition } =
        useContext(CustomCommonContext)

    const { getAllUsers, all_users } = useContext(UserContext)

    const data = props.data
    const toggleCatalogPopup = props.function

    const validationArray = Yup.object({
        categoryTypeId: Yup.string(),
        subCategoryTypeId: Yup.string(),
        uploadFiles: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            categoryTypeId: '',
            subCategoryTypeId: '',
            uploadFiles: [],
            conditionTypeId: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            bulkProjectAction(values)
        },
    })
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])
    const formSubmit = (data) => {
        formik.values.market_status = data
        formik.submitForm().then(setIsLoading(false)).catch(setIsLoading(false))
    }

    const downLoadSample = () =>
        window.open(`${global.site_url}/samples/products.csv`)

    return (
        <FullScreenPopup
            modaltitle={`ADD NEW BULK LISTING`}
            open={data.popup}
            handleClose={() => toggleCatalogPopup(false)}
        >
            <div className="addBulkUpload">
                <div className="fspBody">
                    <div className="row">
                        <div className="col-md-5 col-12 mb-4">
                            <h4 className="fspTitle">
                                Bulk Upload Instructions
                            </h4>
                            <ul>
                                <li>Download the sample file.</li>
                                <li>
                                    Don&apos;t edit the header names . Please
                                    give the appropriate values for each fields.
                                </li>
                                <li>
                                    You have to give proper categoryTypeId.
                                    <ol>
                                        If you want to add the additional
                                        categories please mention the IDs of
                                        those in comma separated. Ex : 2,3,4 .
                                    </ol>
                                </li>
                                <li>
                                    You have to give proper subCategoryTypeId.
                                    <ol>
                                        If you want to add the additional sub
                                        categories please mention the IDs of
                                        those in comma separated. Ex : 2,3,4 .
                                    </ol>
                                </li>
                                <li>
                                    You have to give proper conditionTypeId.
                                </li>
                                <li>
                                    Below are the fields you can enable and
                                    disable them by giving 0 or 1 , that means
                                    it should have 0 or 1
                                    <ol>auction, buynow.</ol>
                                </li>
                                <li>
                                    Below are the fields required.
                                    <ol>
                                        <li>
                                            sprice - must be less than rprice
                                        </li>
                                        <li>
                                            rprice - must be greater sprice and
                                            less than bprice
                                        </li>
                                        <li>
                                            bprice - must be greater or equal
                                            rprice
                                        </li>
                                    </ol>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default Catalogue
